import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=185eb46a&"
import script from "./Works.vue?vue&type=script&lang=js&"
export * from "./Works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports